import React from 'react';

import { Box, Skeleton } from '@rbilabs/universal-components';

import { primitive } from 'styles/constants';

export const CurrencyLineSkeleton = () => (
  <Box width="full">
    <Skeleton
      testID="currency-line-skeleton"
      height="15px"
      width="full"
      color={primitive.$greyFour}
    />
  </Box>
);
